import L from "leaflet";
import gsap from "gsap";

(() => {
	const contactMap = L.map("contactmap").setView([49.621706, 21.2657], 17);
	L.tileLayer(
		"https://api.maptiler.com/maps/toner/{z}/{x}/{y}.png?key=9hjdN2cjPR6s0z16AW22",
		{
			attribution:
				'<a href="https://www.maptiler.com/copyright/" target="_blank">&copy; MapTiler</a> <a href="https://www.openstreetmap.org/copyright" target="_blank">&copy; OpenStreetMap contributors</a>',
		}
	).addTo(contactMap);

	L.marker([49.621706, 21.2657]).addTo(contactMap);
})();

(() => {
	const contactInfo = document.querySelector(".contact-info");

	gsap.from(contactInfo, {
		duration: 1,
		y: "150px",
		opacity: "0",
		delay: 0.4,
	});
})();
